// SankeyChart.js
import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'
import { sankey, sankeyLinkHorizontal } from 'd3-sankey'
const SankeyChart = ({ data, nodeColorMap = {}, nodeOrder = [] }) => {
	const svgRef = useRef()

	const width = 700
	const height = 400

	useEffect(() => {
		const svg = d3.select(svgRef.current)
		svg.selectAll('*').remove()

		const { nodes, links } = sankey()
			.nodeWidth(20)
			.nodePadding(10)
			.nodeSort((a, b) => {
				const aIndex = nodeOrder.indexOf(a.name)
				const bIndex = nodeOrder.indexOf(b.name)
				return aIndex - bIndex
			})
			.extent([
				[1, 1],
				[width - 1, height - 6],
			])({
			nodes: data.nodes.map((d) => Object.assign({}, d)),
			links: data.links.map((d) => Object.assign({}, d)),
		})

		svg
			.attr('viewBox', [0, 0, width, height])
			.append('g')
			.selectAll('path')
			.data(links)
			.join('path')
			.attr('d', sankeyLinkHorizontal())
			.attr('stroke', '#aaa')
			.attr('stroke-width', (d) => Math.max(1, d.width))
			.attr('fill', 'none')
			.attr('opacity', 0.6)

		svg
			.append('g')
			.selectAll('rect')
			.data(nodes)
			.join('rect')
			.attr('x', (d) => d.x0)
			.attr('y', (d) => d.y0)
			.attr('height', (d) => d.y1 - d.y0)
			.attr('width', (d) => d.x1 - d.x0)
			.attr('fill', (d) => nodeColorMap[d.name] || '#69b3a2')

		svg
			.append('g')
			.selectAll('text')
			.data(nodes)
			.join('text')
			.attr('x', (d) => d.x0 - 6)
			.attr('y', (d) => (d.y1 + d.y0) / 2)
			.attr('dy', '0.35em')
			.attr('text-anchor', 'end')
			.text((d) => d.name)
	}, [data, nodeColorMap, nodeOrder])

	return <svg ref={svgRef} style={{ width: '100%', height }} />
}
export default SankeyChart
